@if (storeSvc.hasLocaleObj() && showCalendar()) {
  <div
    class="calendar-container"
    #calendarContainer
    @fade
    [style.margin-bottom.px]="isModal() || isCalendarSidepanel() ? 0 : footerEle()?.nativeElement?.offsetHeight"
  >
    <ngb-datepicker
      #dp
      @fade
      [class]="{
        'w-100': !isMobile(),
        'single-month-layout': noOfMonthsToDisplay() === 1,
        'two-months-layout': noOfMonthsToDisplay() === 2,
      }"
      (dateSelect)="onDateSelection($event)"
      (navigate)="onMonthChange()"
      [displayMonths]="noOfMonthsToDisplay()"
      [dayTemplate]="dpDayTemplate"
      navigation="arrows"
      outsideDays="collapsed"
      [firstDayOfWeek]="calendarStartOnSunday() ? 0 : 1"
      [(ngModel)]="selectedDate"
      [minDate]="minDate()"
      [maxDate]="maxDate()"
    />

    <!-- Change: Improvise this -->
    <ng-template #dpDayTemplate let-date let-focused="focused">
      <!-- template is use to display rates/Complementary/no available/ no checkin /no checkout  -->
      <app-calendar-day
        @fade
        [date]="date"
        [minDate]="minDate()"
        [isFocused]="focused"
        [isHovered]="isHovered(date)"
        [hasDayRateData]="dayRates.has(date.year + '-' + date.month + '-' + date.day)"
        [dayRateData]="dayRates.get(date.year + '-' + date.month + '-' + date.day)"
        [isStartRange]="isStartRange(date)"
        [isInRange]="isInRange(date)"
        [isEndRange]="isEndRange(date)"
        [isNotAvailable]="
          dayRates.has(date.year + '-' + date.month + '-' + date.day) &&
          !dayRates.get(date.year + '-' + date.month + '-' + date.day)?.available &&
          !dayRates.get(date.year + '-' + date.month + '-' + date.day)?.isClosedToArrival &&
          !dayRates.get(date.year + '-' + date.month + '-' + date.day)?.isClosedToDeparture &&
          !dayRates.get(date.year + '-' + date.month + '-' + date.day)?.altPropertyAvailable
        "
        [isComplimentary]="
          dayRates.has(date.year + '-' + date.month + '-' + date.day) &&
          dayRates.get(date.year + '-' + date.month + '-' + date.day)?.available &&
          dayRates.get(date.year + '-' + date.month + '-' + date.day)?.isComplimentary
        "
        [isLoading]="isLoading(date)"
        [priceLoaderConfig]="priceLoaderConfig"
        (mouseenter)="hoveredDate = date"
        (mouseleave)="hoveredDate = null"
      />
    </ng-template>

    <div
      class="d-flex mb-3"
      [class]="isCalendarSidepanel() ? 'justify-content-between align-items-center mt-4' : 'my-4'"
    >
      <app-calendar-indications [isCalendarSidepanel]="isCalendarSidepanel()" />
    </div>

    @if (!isCalendarSidepanel()) {
      <span
        class="calendar-disclaimer text-wrap mb-4"
        [innerHTML]="storeSvc.localeObj()?.tf_1_Calendar_rateCalender_disclaimer"
      ></span>
    }

    @if (!hideSummary()) {
      <app-calendar-summary
        [mobileScreen]="mobileScreen"
        [mobileScreen]="isMobile()"
        [isSelectRoomInProgress]="isSelectRoomInProgress()"
        (onSameDateError)="setErrorMessage('', [], 'SAME-DATE')"
        (onAction)="handleAction($event)"
        [ngClass]="mobileScreen ? '' : 'd-block position-sticky bottom-0 sticky-summary'"
        [class]="
          !isModal() && !isSidePanel() && noOfMonthsToDisplay() === 2
            ? 'd-block position-sticky bottom-0 sticky-summary'
            : ''
        "
      />
    }
  </div>

  @if (isModal() || isSidePanel()) {
    <div
      class="actions-container"
      #footer
      @fade
      [class.fixed-bottom]="isSidePanel()"
      [class.s-px-32]="isSidePanel() && !isMobileLarge()"
      [class.s-px-20]="isSidePanel() && isMobileLarge()"
      [class.s-py-32]="isSidePanel() && !isMobileLarge()"
      [class.s-py-20]="isSidePanel() && isMobileLarge()"
      [class.neutral-white-color-bg]="isSidePanel()"
    >
      <app-button-group
        @fade
        [options]="btnGroupOptions()"
        [classes]="'d-flex justify-content-end'"
        (onClickEvent)="handleModalAction($event)"
      />
    </div>
  }
}
